(function (Drupal, $) {
    Drupal.behaviors.LoginDropdown = {
      attach: function (context) {

        // $('#login-dropdown', context).once('login-dropdown-processed').each(function () {
        //     var node = document.createElement("li")
        //     node.setAttribute("class", "main-menu__item main-menu__item--with-sub login-dropdown-clone");
        //     $("#login-dropdown").clone().appendTo(node)
        //     $(".main-menu.level-0").append(node)
        
        //   });// once


      }
    }
})(Drupal, jQuery);
    